import { NamedError } from "../../utils/Errors";

export class DocumentStorageError extends NamedError<DocumentStorageErrors> {}

export enum DocumentStorageErrors {
    CorruptTranscriptSource = "CorruptTranscriptSource",
    CorruptRecordingEventSource = "CorruptRecordingEventSource",
    WriteContentToClientStorageFailed = "WriteContentToClientStorageFailed",
    WriteContentToClientStorageFailedDuringMigration = "WriteContentToClientStorageFailedDuringMigration",
    DeleteContentFromClientStorageFailed = "DeleteContentFromClientStorageFailed",
    FetchContentXMLPartFromClientStorageFailed = "FetchContentXMLPartFromClientStorageFailed",
    WriteContentToClientStorageTimeOutFailed = "WriteContentToClientStorageTimeOutFailed",
    DeleteContentFromClientStorageTimeOutFailed = "DeleteContentFromClientStorageTimeOutFailed",
    DocumentNotFound = "DocumentNotFound"
}